import { render, staticRenderFns } from "./GListItem.vue?vue&type=template&id=67cf86d6&scoped=true&"
import script from "./GListItem.vue?vue&type=script&lang=js&"
export * from "./GListItem.vue?vue&type=script&lang=js&"
import style0 from "./GListItem.vue?vue&type=style&index=0&id=67cf86d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf86d6",
  null
  
)

export default component.exports